var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoveUserActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2785_447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2532 2.20195C14.3266 0.560152 11.4614 0.855464 9.69301 2.68007L9.00043 3.39375L8.30785 2.68007C6.54301 0.855464 3.67426 0.560152 1.7477 2.20195C-0.460116 4.08632 -0.576131 7.46835 1.39965 9.51093L8.20238 16.5352C8.64184 16.9887 9.35551 16.9887 9.79496 16.5352L16.5977 9.51093C18.577 7.46835 18.461 4.08632 16.2532 2.20195Z",
    fill: "url(#paint0_linear_2785_447)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2785_447",
    x1: 9.00017,
    y1: 1.125,
    x2: 9.00017,
    y2: 16.8753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A50000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2785_447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveUserActive);
export default __webpack_public_path__ + "static/media/Love_user_active.b8affdc07fb4707f851bda46ede0892e.svg";
export { ForwardRef as ReactComponent };